import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ExportedColDef } from '@/shared/models/ag-grid.model'
import { ColDef } from '@ag-grid-community/core'
import { StatisticalAnalysisGeneralStatisticsDossierBaseRequest, StatisticalAnalysisGeneralStatisticsDossierDetailExternalViewTable } from '@/modules/statistical-analysis-module/services/general-statistics-dossier/general-statistics-dossier.dto'
import { generalStatisticsDossierService } from '@/modules/statistical-analysis-module/services/general-statistics-dossier/general-statistics-dossier.service'
import { Nullable } from '@/shared/types/app.types'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisCaseTypes, StatisticalAnalysisExternalListTypes } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisGeneralDossierExternalInfo } from '@/modules/statistical-analysis-module/views/general-statistics-dossier/general-statistics-dossier.model'
import { store } from '@/store/store'
import { getExternalColumnsEntity, getLabAndCaseId } from '@/modules/statistical-analysis-module/shared/helpers/helpers'
import { InfinitePaginatorResponse } from '@/shared/resources/infinite-datasources/infinite-resource.model'
import { isNil } from 'lodash'
import { StatisticalAnalysisDatasourceExternalDetail } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-datasource'

export class StatisticalAnalysisHandlerDatasourceGeneralDossierGeneralList extends StatisticalAnalysisDatasourceExternalDetail<StatisticalAnalysisExternalListTypes> {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisGeneralDossierExternalInfo>
    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisGeneralDossierExternalInfo>) {
        super()
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
    }

    public getGridColumns(): (ColDef | ExportedColDef)[] {
        return getExternalColumnsEntity(this.statisticalAnalysisFilters?.typeSearch?.id as StatiscalAnalysisTypeCases)
    }

    public async paginator(filterModel: CommonFilterModel, params: CommonParams, scrollId: string): Promise<InfinitePaginatorResponse<StatisticalAnalysisExternalListTypes>> {
        const sidebarFilter = this.statisticalAnalysisFilters as StatisticalAnalysisGeneralDossierExternalInfo
        const baseRequest: StatisticalAnalysisGeneralStatisticsDossierBaseRequest = generalStatisticsDossierService.getBaseRequest(sidebarFilter)
        const typeCase = sidebarFilter?.typeSearch?.id?.toLocaleLowerCase() as StatiscalAnalysisTypeCases
        const state = sidebarFilter.trackingGeneralSelected?.key as StatisticalAnalysisCaseTypes
        const response: StatisticalAnalysisGeneralStatisticsDossierDetailExternalViewTable = await generalStatisticsDossierService.getExternalViewGeneralList(filterModel, params, typeCase, state, baseRequest, scrollId, this.getTotalElements())
        if (isNil(this.getTotalElements())) {
            this.setTotalElements(response.scrollPage.totalElements)
        }
        return {
            content: response.content,
            scrollPage: {
                scrollId: encodeURIComponent(JSON.stringify(response.scrollPage.scrollId)),
                size: response.scrollPage.size,
                totalElements: response.scrollPage.totalElements
            }
        }
    }

    public getLabAndCaseId(selectedRow: StatisticalAnalysisExternalListTypes): [number, number] {
        const sidebarFilter = this.statisticalAnalysisFilters as StatisticalAnalysisGeneralDossierExternalInfo
        const typeCase = sidebarFilter?.typeSearch?.id as StatiscalAnalysisTypeCases
        return getLabAndCaseId(typeCase, selectedRow)
    }
}
